"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next13_utils_secure_local_storage_1 = __importDefault(require("@gerenciatd/next13.utils.secure.local-storage"));
const secureCookieStorageLib = new next13_utils_secure_local_storage_1.default();
const hanTranscurridoSeisMeses = (desde, hasta) => {
    let res = false;
    if (desde && hasta) {
        const seisMesesEnMilisegundos = 6 * 30 * 24 * 60 * 60 * 1000; // Asumiendo meses de 30 días
        res = hasta - desde >= seisMesesEnMilisegundos;
    }
    return res;
};
const getUserPersistedInfo = (contextInfo) => {
    let persistedInfo2Use = {};
    let persistedInfo = secureCookieStorageLib.getItem('ts');
    if (persistedInfo && persistedInfo.ts) {
        // check de los 6 meses
        const currentDate = Date.now();
        const lastTs = persistedInfo && persistedInfo.ts;
        const checkSeisMeses = hanTranscurridoSeisMeses(lastTs, currentDate);
        if (checkSeisMeses) {
            persistedInfo = {};
            localStorage.removeItem('ts');
        }
        else {
            persistedInfo2Use = Object.assign({}, persistedInfo);
        }
    }
    return persistedInfo2Use;
};
exports.default = getUserPersistedInfo;
//# sourceMappingURL=persist-utils.js.map